export default __webpack_public_path__ + "img/2_14-e8f6e56c.png";